// extracted by mini-css-extract-plugin
module.exports = {"icon":"NavIcon-module--icon--3B1on","root":"NavIcon-module--root--1JWVx"};